import traffickingScreening from '@/api/traffickingScreening'
// import person from '@/api/person'
import { traffickingScreening as traffickingScreeningModel } from '@/api/models'
import { mergeUserContext } from '@/store/helpers'
import traffickingScreeningFields from './data/traffickingScreeningFields.json'

const state = {
    personTraffickingScreenings: [],
    traffickingScreening: Object.assign({}, traffickingScreeningModel),
    traffickingScreeningFields: traffickingScreeningFields.items,
    createTraffickingScreeningError: false
}

const getters = {
    getTraffickingScreeningsByPerson: state => state.personTraffickingScreenings,
    getTraffickingScreening: state => state.traffickingScreening,
    getTraffickingScreeningFields: state => state.traffickingScreeningFields
}

const actions = {
    async getTraffickingScreeningsByPerson ({ commit, rootState }, payload) {
        payload = mergeUserContext(payload, rootState)
        payload = payload || {}
        const response = await traffickingScreening.getTraffickingScreeningsByPerson(payload)
        const screenings = response.body
        screenings.sort((a, b) => {
            return new Date(b.createdAt) - new Date(a.createdAt)
        })

        if (screenings) {
            commit('SET_PERSON_TRAFFICKING_SCREENINGS', screenings)
        }
    },

    async getTraffickingScreening ({ commit, rootState }, payload) {
        payload = mergeUserContext(payload, rootState)
        payload.id = payload.id
        const response = await traffickingScreening.getTraffickingScreeningsByPerson(payload)
        if (response.body) {
            commit('SET_TRAFFICKING_SCREENING', response.body[0])
        }
    },

    async createTraffickingScreening ({ commit, rootState }, payload) {
        payload = mergeUserContext(payload, rootState)
        // console.log('createTraffickingScreening rootState, payload: ', rootState, payload)
        const response = await traffickingScreening.createTraffickingScreening(payload)
        // console.log('createTraffickingScreening response: ', response)
        if (response.error) {
            // display error
            commit('SET_CREATE_TRAFFICKING_SCREENING_ERROR', true)
        } else {
            commit('SET_CREATE_TRAFFICKING_SCREENING_ERROR', false)
            commit('SET_TRAFFICKING_SCREENING', response.body)
        }
    },

    initCreateTraffickingScreening ({ commit }) {
        commit('SET_CREATE_TRAFFICKING_SCREENING_ERROR', false)
        commit('SET_TRAFFICKING_SCREENING', Object.assign({}, traffickingScreeningModel))
    }
}

const mutations = {
    SET_PERSON_TRAFFICKING_SCREENINGS (state, payload) {
        state.personTraffickingScreenings = payload
    },

    SET_TRAFFICKING_SCREENING (state, payload) {
        state.traffickingScreening = payload
    },

    SET_CREATE_TRAFFICKING_SCREENING_ERROR (state, payload) {
        state.createTraffickingScreeningError = payload
    },

    UPDATE_TRANSFERRED_TRAFFICKINGSCREENING (state, payload) {
        state.traffickingScreening = payload
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/traffickingScreening.js